<p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>

<div class="content">

  <div class="page-title">
    <h1>Job Management</h1>

    <div class="add" (click)="add()">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </div>
  </div>

  <div class="card">
    <form class="card-title" (submit)="rebind()">
      <h3><i class="fa fa-search" aria-hidden="true"></i> Search Filters</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Companies</label>
            <app-company-picker [accountId]="filter.companyId" [_placeholder]="'All'" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label>Locations</label>
            <app-location-picker [locationId]="filter.locationId" [companyId]="filter.companyId" [_placeholder]="'All'" (onLocationSet)="onLocationChange($event)"></app-location-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Engineer</label>
            <app-technician-picker [technicianId]="filter.technicianId" [_placeholder]="'All'" (onTechnicianSet)="onTechnicanChange($event)"></app-technician-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Completed</label>

            <ng-select [items]="completed_Statuses" [ngModelOptions]="{standalone: true}" bindLabel="Name" bindValue="Value" [virtualScroll]="true"
                       placeholder="All" [(ngModel)]="filter.completed" [selectOnTab]="true">
            </ng-select>
          </div>
        </div>

      </div>


      <div class="row buffer-bottom">
        <div class="col-md-3 col-sm-6">
          <label>Job Number</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="filter.job_Num" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input type="submit" class="btn btn-primary" value="Refresh" />
          <button (click)="resetFilters()" value="Reset" class="btn reset-data">Reset</button>
          <!--<input type="button" value="Export" class="pull-right btn btn-primary" (click)="generateExcel()" />-->
        </div>
      </div>

    </form>
  </div>

  <app-loading-icon *ngIf="loading"></app-loading-icon>

  <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                 [rowHeight]="'auto'" [limit]="10" *ngIf="!loading">


    <ngx-datatable-column name="Company" prop="company_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Location" prop="location_Name">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Job Number" prop="job_No">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Contract" prop="contract_No">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Engineer" prop="engineer_Name_Formatted">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Proposed Date" prop="proposed_Date">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div *ngIf="row.proposed_Date != null">{{ value | date: 'dd/MM/yyyy' }}</div>
        <div *ngIf="row.proposed_Date == null">N/A</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Week Commencing" prop="week_Commencing">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div *ngIf="row.week_Commencing != null">{{ value | date: 'dd/MM/yyyy' }}</div>
        <div *ngIf="row.week_Commencing == null">N/A</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Completed Date" prop="completed_Date">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <div *ngIf="row.completed_Date != null">{{ value | date: 'dd/MM/yyyy' }}</div>
        <div *ngIf="row.completed_Date == null">N/A</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Approve">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div (click)="complete(row)" *ngIf="row.completed_Date != null && !row.approved" class="edit-option"><i class="fa fa-tick" aria-hidden="true"></i>Approve</div>
        <div *ngIf="row.completed_Date == null">N/A</div>
        <div *ngIf="row.completed_Date != null && row.approved">Approved</div>

      </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column name="Edit">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span (click)="edit(row)" class="edit-option"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</span>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>
</div>
